import range from 'lodash/range'

import MoreOutlinedIcon from '@ant-design/icons/MoreOutlined'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import LinearProgress from '@components/LinearProgress'

import { useSOPsFilters } from '../SOPsList/SOPsList.hooks'
import SOPNotification from './SOPNotification'
import { useSOPsNotifications } from './SOPsNotifications.hooks'

export default function SOPsNotifications() {
  const [filters, updateFilters] = useSOPsFilters()
  const { data, isPending, isRefreshing, fetchNextPage, hasNextPage, isFetchingNextPage } = useSOPsNotifications()

  const showLoading = isPending
  const showEmpty = !showLoading && data?.length === 0
  const showData = !showEmpty && data?.length > 0

  return (
    <Stack>
      <LinearProgress loading={isRefreshing} />
      <Stack sx={{ gap: 2 }}>
        {showLoading && (
          <Stack sx={styles.rows}>
            {range(5).map((i) => (
              <SOPNotification.Loading key={i} />
            ))}
          </Stack>
        )}
        {showEmpty && <Empty data-testid="sops-notifications-empty">No SOP updates found yet</Empty>}
        {showData && (
          <Stack sx={styles.rows}>
            {data.map((notification) => (
              <SOPNotification
                key={notification.id}
                data={notification}
                selected={String(notification.sopNotification.sop.id) === String(filters.sopId)}
                onSelect={() => updateFilters({ sops: 'view', sopId: notification.sopNotification.sop.id })}
              />
            ))}
          </Stack>
        )}
        {hasNextPage && (
          <Button
            fullWidth
            loading={isFetchingNextPage}
            onClick={() => fetchNextPage()}
            endIcon={<MoreOutlinedIcon rotate={90} />}
            loadingPosition="end"
            sx={{ textTransform: 'none' }}
            data-testid="sops-notifications-load-more"
          >
            more
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

function Empty({ children, ...rest }) {
  return (
    <Stack sx={{ p: 2, alignItems: 'center', justifyContent: 'center' }} {...rest}>
      <Typography variant="h5" sx={{ color: 'text.secondary' }}>
        {children}
      </Typography>
    </Stack>
  )
}

const styles = {
  rows: {
    px: 1,
    gap: 0.25,
  },
}
